import axios from 'axios';

const makeDefaultAddressApi = async (
  values,
  token,
  langIsoCode,
  edit = false
) => {
  try {
    const res = await axios.post('/Address/makeDefault', values, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default makeDefaultAddressApi;
